/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbMetierGridDto } from './FcbMetierGridDto';
import {
    FcbMetierGridDtoFromJSON,
    FcbMetierGridDtoFromJSONTyped,
    FcbMetierGridDtoToJSON,
} from './FcbMetierGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbMetierGridDtoPaginatedResults
 */
export interface FcbMetierGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbMetierGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbMetierGridDto>}
     * @memberof FcbMetierGridDtoPaginatedResults
     */
    results?: Array<FcbMetierGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbMetierGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbMetierGridDtoPaginatedResults interface.
 */
export function instanceOfFcbMetierGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbMetierGridDtoPaginatedResultsFromJSON(json: any): FcbMetierGridDtoPaginatedResults {
    return FcbMetierGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbMetierGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbMetierGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbMetierGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbMetierGridDtoPaginatedResultsToJSON(value?: FcbMetierGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbMetierGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

